import { Search } from '@mui/icons-material'
import { Box, CircularProgress, Divider, Typography } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import PayrunHeader from '../../payroll-run/components/Header'
import TotalSummary from 'module/payroll/global-components/TotalSummary'
import { useQuery } from 'react-query'
import { retrieveEmployeeData } from 'services/api/modules/payroll/payroll-view'
import { retrieveSummaryData } from 'services/api/modules/payroll/payroll-summary'
import AdxSortTable from 'components/reusable/table/AdxSortTable'
import { PayrollSummaryTableHeader } from '../components/PayrollSummaryTableHeader'
import SummaryDetails from '../components/SummaryDetails'
const PayrollSummary = ({ time }) => {
  const { data: retrieveData, isLoading: loadingData } = useQuery(
    ['retrieveEmployeeData', time],
    () => retrieveEmployeeData(time)
  )
  const { data: retrieveSummary, isLoading: loadingSummary } = useQuery(
    ['retrieveSummaryData', time],
    () => retrieveSummaryData({ time_id: time })
  )
  //time
  const [timeId, setTimeId] = useState()

  //employee details
  const [employeeDetails, setEmployeeDetails] = useState([])

  //summary
  const [summaryData, setSummaryData] = useState([])

  const [keywords, setKeywords] = useState('')
  const [filteredEmployee, setFilteredEmployee] = useState([])

  let navigate = useNavigate()
  const handleReturn = () => {
    navigate(-1)
  }
  useEffect(() => {
    if (retrieveData) {
      let employeeData = retrieveData?.data?.slice().sort((a, b) => (a.status > b.status ? -1 : 1))
      setEmployeeDetails(employeeData)
      setTimeId(retrieveData)
    }
  }, [retrieveData])

  useEffect(() => {
    if (retrieveSummary) {
      let summary = retrieveSummary?.data
      setSummaryData(summary)
    }
  }, [retrieveSummary])

  useEffect(() => {
    if (employeeDetails) {
      let arr = employeeDetails?.filter((item) => {
        if (keywords === '') {
          return item
        } else if (item.name.toLowerCase().includes(keywords.toLowerCase())) {
          return item
        } else {
          // const emptyArray = [];
          return null
        }
      })
      setFilteredEmployee(arr)
    }
  }, [keywords, employeeDetails])
  const claimsInPayroll = !!retrieveData?.claims_in_payroll
  const columnHeader = useMemo(
    () =>
      claimsInPayroll
        ? PayrollSummaryTableHeader
        : PayrollSummaryTableHeader.filter((column) => column.accessor !== 'salary.claim'),
    [claimsInPayroll]
  )

  const [drawerState, setDrawerState] = useState({ right: false })
  const [employeeDetail, setEmployeeDetail] = useState({})
  const handleDrawer = (anchor, open) => (event) => {
    setDrawerState({ ...drawerState, [anchor]: open })
  }
  const viewDetails = (details) => {
    setDrawerState({ ...drawerState, right: true })
    setEmployeeDetail(details)
  }
  return (
    <Box sx={{ bgcolor: 'gray-background.main', width: '100vw' }}>
      <PayrunHeader
        nextButton="Submit payroll"
        backButton="Back"
        handleReturn={handleReturn}
        payrollPeriod={timeId}
        loadingData={loadingData}
        time_id={time}
      />
      <Divider sx={{ color: 'gray-line.main' }} />
      <Box padding={3} boxSizing="border-box">
        <Typography variant="h4" sx={{ fontWeight: 600, mb: 2 }}>
          Summary
        </Typography>
        <TotalSummary
          totalSum={summaryData}
          filteredEmployee={filteredEmployee}
          timeStamp={timeId}
          loadingSummary={loadingSummary}
          showClaims={claimsInPayroll}
        />
        <Box>
          <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ my: 3 }}>
            <Typography variant="h4" sx={{ fontWeight: 600 }}>
              Employee
            </Typography>
            <AdxInput
              type="standard"
              startAdornment={<Search color="light-gray-text" sx={{ mr: 1 }} />}
              onChange={(e) => setKeywords(e.target.value)}
              sx={{
                width: 'auto',
                '& .MuiInputBase-root': {
                  minHeight: '45px',
                  width: '500px',
                  outlineColor: '#E5E5E5',
                  bgcolor: 'white.main',
                },
              }}
              placeholder="Search employee name"
            />
          </Box>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
              backgroundColor: 'white.main',
              border: 1,
              borderColor: 'gray-line.main',
              borderRadius: '4.5px',
              overflow: 'auto',
            }}
          >
            {loadingData ? (
              <CircularProgress color="alternate" size={60} />
            ) : (
              <>
                <AdxSortTable
                  data={filteredEmployee}
                  onClick={viewDetails}
                  column={columnHeader}
                  allColumnSorted={false}
                  stickyHeader="stickyHeader"
                  height={'calc(100vh - 470px)'}
                  divClick
                />
                <SummaryDetails
                  drawerState={drawerState}
                  handleDrawer={handleDrawer}
                  details={employeeDetail}
                  time_id={time}
                  sendPayslip={false}
                />
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default PayrollSummary
